/**
 * The z-index of an @erebus/ui DrawerSurface (its `z-[1500]` class). Its contract is
 * that anything opened from inside a surface, like a dialog or a toast, covers it.
 */
export const DRAWER_SURFACE_Z_INDEX = 1500;

/**
 * PrimeVue's stacking bases, set above DrawerSurface. PrimeVue's defaults (1100 for a
 * dialog) would open the schedule's "Discard all" confirm under the phone's review
 * sheet. PrimeVue's own order is kept: tooltips over everything else.
 */
export const PRIMEVUE_Z_INDEX = {
  modal: DRAWER_SURFACE_Z_INDEX + 100,
  overlay: DRAWER_SURFACE_Z_INDEX + 100,
  menu: DRAWER_SURFACE_Z_INDEX + 100,
  tooltip: DRAWER_SURFACE_Z_INDEX + 200,
};
